/**
 * @function       isMobile
 * @description    a jQuery function to detect mobile devices
 * @param          userAgents [array]
 * @return         object
 available devices to detect = 'iPad', 'iPhone', 'Android', 'IEMobile', 'BlackBerry'
 */

var userAgents = [ 'iPhone' ];

function isMobile(userAgents) {
    var userAgent,
        isMobile = { 
            any: false
        };

    $.each(userAgents, function (index) {
        userAgent = userAgents[index];

        isMobile[userAgent] = navigator.userAgent.toLowerCase().indexOf(userAgent.toLowercase()) > -1;

        if (isMobile[userAgent]) isMobile.any = true;
    });

    return isMobile;
}